import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const AlertIcon12 = (props: SvgProps) => <Svg
  width='12'
  height='12'
  viewBox='0 0 12 12'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M6 1.25C6.41421 1.25 6.75 1.58579 6.75 2V7C6.75 7.41421 6.41421 7.75 6 7.75C5.58579 7.75 5.25 7.41421 5.25 7V2C5.25 1.58579 5.58579 1.25 6 1.25Z'
    fill='white'
  />
  <Path
    d='M7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9C6.55228 9 7 9.44772 7 10Z'
    fill='white'
  />
</Svg>;

export default AlertIcon12;
